export const de = {
  "selectize.add_button": "%{value} hinzufügen"
}